<template>
<div class="container mar-t-70 mb20 resp70">
  <div class="flexrow_green mb50" >
    <div class="subheader_flex">
      <h1 class="nomargin redhigh">Edit Member</h1>
    </div>
    <div class="flexcircle">
      <router-link :to="{name: 'member_info', params: {id: this.$route.params.eid}}"  class="btn btn-vermilion">Back</router-link>
    </div>
  </div>
  <div class="row">
    <div class="container ">
      <div class="col-lg-8 offset-lg-2  bg-white bx-shaw pad40">

          <ValidationObserver  ref="observer" v-slot="{ invalid }"  @submit.prevent="submitpage()">
        <form class="mar-t-30" >
          <div class="form-group">
              <span class="loginerror">{{errorreport}}</span>
          </div>
          <div class="form-group">
            <ValidationProvider rules="required" name="First Name" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="First Name" v-model = "member.first_name" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Last Name" v-model = "member.last_name" >
          </div>
          <div class="form-group">
            <ValidationProvider :rules="{required: true, regex: /^[6-9]\d{9}$/}" name="Phone Number" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="Phone Number" v-model="member.phone" >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>
          <div class="form-group">
            <!-- <label for="">Address</label> -->
            <textarea type="text" class="form-control" placeholder="Address" v-model="member.address" ></textarea>
          </div>
          <div class="form-group">
            <ValidationProvider :rules="{required: true, regex: /^[ A-Za-z0-9_@-]*$/}" name="User Id" v-slot="{ errors }">
            <input type="text" class="form-control" placeholder="User Id" v-model = "member.username" readonly >
            <span class="loginerror">{{ errors[0] }}</span>
          </ValidationProvider>
          </div>

          
    <div class="text-center mb0">
      <button :disabled="isdisabled" type="submit" class="submit-button">Submit</button>

    </div>
        </form>
          </ValidationObserver>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
  name: 'editmember',
  data () {
    return {
      isdisabled: false,
      admininfo: {
      },
      storeinfo: {},
      member: {
      },
      editor: ClassicEditor,
      files: [],
      error: false,
      errorreport: '',
      postImageUrl: ''
    }
  },
  mounted () {
    this.getadmininfo()
    this.storeinfoo()
  },
  methods: {
    getadmininfo () {
      this.$http.get('/register/getadmininfo/' + this.$route.params.eid).then((response) => {
        if (response.data.success === true) {
          this.admininfo = response.data.details[0]
        }
      })
    },
    storeinfoo () {
      this.$http.get('/register/getstoreinfo/' + this.$route.params.eid).then((response) => {
        if (response.data.success === true) {
          this.storeinfo = response.data.details[0]


var output = {};
output = this.jsonConcat(output, this.admininfo);
output = this.jsonConcat(output, this.storeinfo);
this.member = output
console.log(this.member)
        }
      })
    },
     jsonConcat(o1, o2) {
       console.log(o1)
       console.log(o2)
for (var key in o2) {
o1[key] = o2[key];
}
return o1;
},

    uploadChange ($event) {
      this.convertBase64($event.target)
    },
    convertBase64 (inputValue) {

      const file = inputValue.files[0]
  console.log(file)
      this.files.push({filee: file})
      const myReader = new FileReader()
      myReader.onloadend = (e) => {
        this.postImageUrl = myReader.result
        this.ImageUrl = myReader.result
      }
      myReader.readAsDataURL(file)
    },

async submitpage () {
  this.vueloaders = true
  const isValid = await this.$refs.observer.validate()
if (isValid) {
  this.isdisabled = true
this.errorreport = ''
  this.$http.put('/register/edit-profile/' + this.$route.params.eid, this.member).then((res) => {
    if (res.data.success === true) {
        this.$router.push('/member_info/' + this.$route.params.eid)
    }
    this.isdisabled = false
  }).catch((err) => {
    this.isdisabled = false
    console.log(err)
  })
} else {
  console.log('required feilds')
// this.errorreport = "All Feilds Are Required."
}
}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/edit-member.vue